import React from "react";
import { pure } from "recompose";
import styled from "styled-components";
import Loader from "../../../../components/Loader/Loader";

const Container = styled.div`
  position: fixed;
  bottom: 50%;
  top: 50%;
  z-index: 4000;
`;

function ARILoader() {
  return (
    <Container id="hotelCardLoader" className="wbkv9-RoomSelection-loaderContainer">
      <div>
        <Loader />
      </div>
    </Container>
  );
}

ARILoader.propTypes = {};

export default pure(ARILoader);
